var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.98,
    height: 14,
    viewBox: "0 0 13.98 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "location_Frame_Background_",
    "data-name": "location [Frame Background]",
    width: 13.98,
    height: 14,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_location",
    "data-name": "vuesax/bold/location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.369,11.066a3.155,3.155,0,0,1-4.4,0C1.3,9.462-.536,6.913.146,3.9A5.025,5.025,0,0,1,5.167,0h.006a5.026,5.026,0,0,1,5.021,3.908c.682,3.01-1.159,5.553-2.825,7.158ZM7.007,4.993A1.835,1.835,0,1,0,5.173,6.831,1.836,1.836,0,0,0,7.007,4.993Z",
    transform: "translate(1.817 1.021)",
    fill: "#4258bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H13.98V14H0Z",
    fill: "#4258bf",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H13.98V14H0Z",
    transform: "matrix(-1, 0, 0, -1, 13.98, 14)",
    fill: "#4258bf",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.396b580164a618703e07f2751842297a.svg";
export { ForwardRef as ReactComponent };